      <template v-slot:default="{ hide }">

        <div class="px-3 py-2 filter-wrapper">

            <div>

                <b-form-group label="Employee Name" label-for="filter_employee_name" class="mb-2">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input id="filter_employee_name" type="search" name="Employee Name"
                            placeholder="Employee Name" v-model="search_by_filter['name']"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group label="Employee Code" label-for="filter_employee_code" class="mb-2">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input id="filter_employee_code" type="search" name="Employee Code"
                            placeholder="Employee Code" v-model="search_by_filter['employee_code']"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </div>
            <div v-for="(row, index3) in company_options" :key="index3 + row.label">
                <div v-if="row.options.length > 0">
                    <div>
                        <b-form-group :label="stringView(row.label)" :label-for="'filter_' + row.label" class="mb-2">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="list"></b-icon>
                                </b-input-group-prepend>
                                <select :id="'filter_' + row.label" :name="row.label" class='form-control'
                                    v-model="search_by_filter[row.label + '_id']">
                                    <option value=''>Select {{ stringView(row.label) }}</option>
                                    <option v-for='data in row.options' :value='data.id' :key="data.id + data.name">{{
                                        data.name }}</option>
                                </select>
                            </b-input-group>
                        </b-form-group>
                    </div>

                </div>
            </div>

            <div class="mt-4 row">
                <div class="col-6">
                    <b-button class="filter_btn" v-b-toggle.sidebar_right variant="primary" block title="Set Filter">
                        <div>Set Filter</div>
                    </b-button>
                </div>
                <div class="col-6">
                    <b-button class="filter_btn" variant="primary" block title="Clear Filter" @click="resetFlter();">
                        <div>Clear Filter</div>
                    </b-button>
                </div>
            </div>
        </div>
    </template>


<script>
export default {
    props: ['company_options', 'search_by_filter'],

    data() {
        return {
            filter_by_id: ['jobposition', 'department', 'branch'],
            filter_by_id_options: [{ jobposition: "jobposition_id" }, { department: "department_id" }, { branch: "branch_id" }],
        }
    },
    methods: {

        generateFilterOptions: function () {
            let value = [];
            value['reset'] = 0;
            value['search_by_filter'] = this.search_by_filter;
            this.$emit('childToParent', value);

        },
        stringView(str) {
            var i, frags = str.split('_');
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },
        resetFlter: function () {
            let value = [];
            value['reset'] = 1;
            let cr = this.search_by_filter;
            let defaultval = {};
            Object.keys(this.search_by_filter).forEach(key => {

                defaultval[key] = '';
            });
            value['search_by_filter'] = defaultval;
            this.$emit('childToParent', value);
        },
    },
    created: function () {
        this.generateFilterOptions();
    }
}
</script>
